import { InjectionToken } from '@angular/core';

export const RXAP_FORM_ADD_ITEM_FORM_CONSTRUCTOR = new InjectionToken('rxap/forms/add-item-form-constructor');
